import React, { useState, useEffect } from 'react';
import Post from '../../../../utils/Post';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import { activeDialog } from '../../../../utils/Common';
import LineaDeAvance from '../NETJET/componentes/LineaDeAvance';
import Verifiers from '../../../../utils/Verifiers.jsx';

const ReporteEjecucionPlanCampo = () => {
    //http://localhost:8080/campo/v2/inventarios/ejecucion/reporte
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    const [filtros, setfiltros] = useState({ semanas: [], variedades: [], colores: [], flores: [], ranchos: [], valvulas: [] });
    const [paginador, setpaginador] = useState({ semana: '2410', variedad: '', color: '', flor: '', rancho: '', valvula: '' });
    const [data, setdata] = useState([]);
    const campoFiltroNombre = { 'semanas': 'semana', 'flores': 'flor', 'variedades': 'variedad', 'colores': 'color', 'ranchos': 'rancho', 'valvulas': 'valvula' };
    const dias = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
    var counter = 0; const [totales, settotales] = useState({
        "ejecutado": 0,
        "planeado": 0,
        "lunes_plan": 0,
        "lunes_ejecutado": 0,
        "martes_plan": 0,
        "martes_ejecutado": 0,
        "miercoles_plan": 0,
        "miercoles_ejecutado": 0,
        "jueves_plan": 0,
        "jueves_ejecutado": 0,
        "viernes_plan": 0,
        "viernes_ejecutado": 0,
        "sabado_plan": 0,
        "sabado_ejecutado": 0,
        "diferencia": 0,
        "porcentaje_ejecutado": 0,
        "tipo_diferencia": ''
    });

    useEffect(() => {
        getData(paginador, true);
    }, []);

    const keyGen = () => { counter++; return counter; }

    /**
    * Obtiene los datos de ejecución del plan de campo y los filtros asociados a ese, el proceso se realiza correctamente se llenan las variables de estado
    * @param {object} pg paginador con opciones de filtrado, si no se manda se usa el actual   
    * @param {boolean} loader True si se desea activar la animación de carga, falso si no
    * @returns vold
    */
    const getData = async (pg = { ...paginador }, loader = false) => {
        let resp = await Post('/campo/v2/inventarios/ejecucion/reporte', pg, 'POST', loader ? setloader : false);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Error');
            return false;
        }
        setpaginador(pg);
        setdata(resp.data);
        setfiltros(resp.filtros);
        settotales(resp.totales);
        Verifiers.scrollAnimacion('lista_normal0', 250);
    }

    /**
     * ajusta el paginador y solicita una nueva consulta usando el nuevo paginador
     * @param {object} e evento del input
     */
    const aplicarFiltro = (e) => {
        let { name, value } = e.target;
        let pg = { ...paginador, [name]: value };
        if (name === 'semana') {
            pg = { semana: value, variedad: '', color: '', flor: '', rancho: '', valvula: '' };
        }
        getData(pg, true);
    }

    return (
        <div className='vw-100 p-2 overflow bg-white p-2 dosis' style={{ height: "calc( 100vh - 60px)" }}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='w-100 round-left-xxl gradient-small-black text-white text-300 p-1 ps-3 text-l'>  Reporte ejecucion plan de campo  </div>


                {Object.keys(filtros).map((f, i) =>
                    <div className='form-group bw-150 boorder border-bottom pb-1 round-xxl mt-2' key={keyGen()}>
                        <label className='text-bold text-xs ps-3'>{campoFiltroNombre[f].toUpperCase()}</label>
                        <select className={'form-control form-control-sm shadow border round-xxl ' + (campoFiltroNombre[f] === 'semana' ? 'tborder-2 border-warning' : '')}
                            name={campoFiltroNombre[f]}
                            value={paginador[campoFiltroNombre[f]]}
                            onChange={aplicarFiltro}>
                            <option value='' >{f == 'semanas' ? "Seleccione una" : "Sin filtrar"}</option>
                            {filtros[f].map((filtro, j) =>
                                <option key={keyGen()} value={f === 'semanas' ? filtro : filtro.key}>{f === 'semanas' ? filtro : filtro.value.toUpperCase()}</option>
                            )}
                        </select>
                    </div>
                )}
                <div className='w-100 mt-2' />
                <LineaDeAvance avance={totales.porcentaje_ejecutado > 100 ? 100 : totales.porcentaje_ejecutado} bwWidth='bw-1400 round-xxl' height={3} />
                <div className='w-100 mt-2' />
                <div className='bw-250 bg-black3 round-s text-white text-m text-center mb-1 mt-1 border-bottom m-0 p-0'>
                    <span className='w-100 text-s m-0 p-0 me-2 '>Total pl. planeado</span>
                    {totales.plantas_plan}
                </div>
                <div className='bw-250 bg-black3 round-s text-white text-m text-center mb-1 mt-1 border-bottom m-0 p-0'>
                    <span className='w-100 text-s m-0 p-0 me-2 '>Total pl. ejecutado</span>
                    {totales.total_plantas_ejecutado}
                </div>
                <div className='bw-250 bg-black3 round-s text-white text-m text-center mb-1 mt-1 border-bottom m-0 p-0'>

                    {totales.diferencia}<span className='w-100 text-s m-0 p-0 ms-2 '>plantas {totales.tipo_diferencia.toLowerCase()}s</span>
                </div>
                <div className='bw-250 bg-black3 round-s text-white text-m text-center mb-1 mt-1 border-bottom m-0 p-0'>
                    <span className='w-100 text-s m-0 p-0 me-2 '>Avance</span>
                    {totales.porcentaje_ejecutado}%
                </div>
                <div className='w-100 mt-2' />
                <div className='bw-1300 p-1 m-0 border-bottom border-top border-dark overflow' style={{ height: '70vh' }}>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        {data.map((d, i) =>
                            <React.Fragment key={keyGen()}>
                                <div className='bw-1200 p-1 shadow border border-2 round-s mb-2 mt-2 ps-2 pe-2'>
                                    <LineaDeAvance avance={d.porcentaje_ejecutado > 100 ? 100 : d.porcentaje_ejecutado} bwWidth='w-100' />
                                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                                        <div className='bw-300 text-m text-bold border-bottom border-warning m-0 p-0'>
                                            <div className='w-100 text-xs m-0 p-0'>Flor</div>
                                            {d.flor}
                                        </div>
                                        <div className='bw-150 text-m text-center text-bold border-bottom border-secondary m-0 p-0'>
                                            <div className='w-100 text-xs m-0 p-0'>Plantas planeadas</div>
                                            {d.plantas_plan}
                                        </div>
                                        <div className='bw-150 text-m text-center text-bold border-bottom border-secondary m-0 p-0'>
                                            <div className='w-100 text-xs m-0 p-0'>Plantas ejecutadas</div>
                                            {d.total_plantas_ejecutado}
                                        </div>
                                        <div className={`bw-150 text-m text-center text-bold border-bottom border-secondary m-0 p-0 ${d.tipo_diferencia === 'Excedente' ? 'text-blue3' : 'text-danger'}`}>
                                            <div className='w-100 text-xs m-0 p-0 text-dark'>{d.tipo_diferencia}</div>
                                            {d.diferencia}
                                        </div>

                                        <div className={`bw-150 text-m text-center text-bold border-bottom border-secondary m-0 p-0`}>
                                            <div className='w-100 text-xs m-0 p-0 text-dark'>Porcentaje avance</div>
                                            {d.porcentaje_ejecutado}%
                                        </div>

                                        <div className='w-100 m-0 p-0'></div>
                                        {dias.map((dia, j) =>
                                            <div key={keyGen()} className='p-0 m-0 text-center border-satart border-end text-s mt-1 mb-1 shadow-sm bw-150 round-m'>
                                                <div className='w-100 text-xs text-bold opacity-80 text-center'>
                                                    {dia.toUpperCase()}, Plan<span className='text-bold ms-1 me-1'>|</span>Ejecutado
                                                </div>
                                                {d[dia + "_plan"]}  <span className='text-bold ms-1 me-1'>|</span> {d[dia + "_ejecutado"]}
                                            </div>
                                        )}

                                    </div>
                                </div>
                                <div className='w-100 m-0 p-0'></div>
                            </React.Fragment>
                        )}
                    </div>
                </div>



            </div>
            <VainillaDialog data={dialog} />
            {loader && ldr}
        </div >
    )
}

export default ReporteEjecucionPlanCampo;